module.exports = __webpack_public_path__ + "static/media/taptheball.e3e6ce9c.png";